export default __webpack_public_path__ + "static/media/case-study2.55faaef5.webp";